import styled, { css } from 'styled-components';
import { fontSize } from '../../styles/fonts';
import sizes from '../../styles/sizes';

// uncommon vertical padding to achieve 40px and 48px height
var PADDING_Y = {
  large: '0.9375em',
  regular: '0.8582em'
};
var PADDING_X = {
  large: '1.8666em',
  regular: '1.7142em'
};
var PADDING_ICON = {
  large: '1.2em',
  regular: '1em'
};
var MARGIN_ICON = {
  large: '-0.4em',
  regular: '-0.365em'
};
var ICON_SIZE = {
  large: sizes.sz20,
  regular: sizes.sz16
};
var FONT_SIZES = {
  large: fontSize.ft16,
  regular: fontSize.ft14
};
var WIDTH = {
  auto: 'auto',
  full: '100%'
};
var SIZE = {
  extraLarge: '64px',
  large: '48px',
  regular: '40px'
};
var primaryCommon = /*#__PURE__*/css(["border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover{background:", ";border:1px solid ", ";color:", ";}&:focus:not(:active){box-shadow:inset 0 0 0 1px rgba(255,255,255,0.37);border:1px solid rgba(255,255,255,0.37);background:", ";color:", ";}&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){background:", ";color:", ";svg{fill:", ";stroke:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.button.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.background.lightPrimary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.border.lightPrimary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.text.inverted;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.background.lightPrimary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text.inverted;
}, function (_ref11) {
  var isLoading = _ref11.isLoading,
    theme = _ref11.theme;
  return !isLoading ? theme.colors.button.gray : theme.colors.button.primary;
}, function (_ref12) {
  var isLoading = _ref12.isLoading,
    theme = _ref12.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref13) {
  var isLoading = _ref13.isLoading,
    theme = _ref13.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref14) {
  var isLoading = _ref14.isLoading,
    theme = _ref14.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
});
var secondaryCommon = /*#__PURE__*/css(["border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover{border:1px solid ", ";background:", ";color:", ";}&:focus:not(:active){border:1px solid ", ";box-shadow:inset 0 0 0 1px ", ";background:", ";color:", ";}&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){background:", ";color:", ";svg{fill:", ";stroke:", ";}}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.border.primary;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.button.white;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.text.secondary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.text.secondary;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.text.secondary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.border.primary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.background.secondary;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.text.secondary;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.border.primary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.border.primary;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.background.secondary;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.text.secondary;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.button.white;
}, function (_ref28) {
  var isLoading = _ref28.isLoading,
    theme = _ref28.theme;
  return !isLoading ? theme.colors.text.gray : theme.colors.text.secondary;
}, function (_ref29) {
  var isLoading = _ref29.isLoading,
    theme = _ref29.theme;
  return !isLoading ? theme.colors.text.gray : theme.colors.text.secondary;
}, function (_ref30) {
  var isLoading = _ref30.isLoading,
    theme = _ref30.theme;
  return !isLoading ? theme.colors.text.gray : theme.colors.text.secondary;
});
var quaternaryCommon = /*#__PURE__*/css(["border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover,&:focus{background:", ";border:1px solid ", ";color:", ";svg{fill:", ";stroke:", ";}}&:focus:not(:active){box-shadow:inset 0 0 0 1px rgba(255,255,255,0.37);border:1px solid rgba(255,255,255,0.37);background:", ";color:", ";}&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){background:", ";color:", ";svg{fill:", ";stroke:", ";}}"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.background.cta;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.button.cta;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.text.lightPrimary;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.colors.text.tertiary;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.text.tertiary;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors["default"].blueE;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.colors.border.tertiary;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.colors.text.white;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.colors.text.white;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.colors.text.white;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.colors["default"].blueE;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.colors.text.white;
}, function (_ref43) {
  var isLoading = _ref43.isLoading,
    theme = _ref43.theme;
  return !isLoading ? theme.colors.button.gray : theme.colors.button.primary;
}, function (_ref44) {
  var isLoading = _ref44.isLoading,
    theme = _ref44.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref45) {
  var isLoading = _ref45.isLoading,
    theme = _ref45.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref46) {
  var isLoading = _ref46.isLoading,
    theme = _ref46.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
});
var pill = /*#__PURE__*/css(["width:", ";border-radius:1000px;padding:", ";padding-left:", ";padding-right:", ";font-weight:", ";font-size:", ";&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){border:1px solid ", ";box-shadow:none;padding:", ";padding-left:", ";padding-right:", ";}"], function (_ref47) {
  var stretch = _ref47.stretch;
  return WIDTH[stretch];
}, function (_ref48) {
  var size = _ref48.size;
  return "".concat(PADDING_Y[size], " ").concat(PADDING_X[size]);
}, function (_ref49) {
  var size = _ref49.size,
    leftIcon = _ref49.leftIcon,
    isLoading = _ref49.isLoading;
  return leftIcon || isLoading ? PADDING_ICON[size] : null;
}, function (_ref50) {
  var rightIcon = _ref50.rightIcon,
    size = _ref50.size;
  return rightIcon ? PADDING_ICON[size] : null;
}, function (_ref51) {
  var weight = _ref51.weight,
    theme = _ref51.theme;
  return theme.fonts.fontWeight[weight];
}, function (_ref52) {
  var theme = _ref52.theme,
    size = _ref52.size;
  return size === 'large' ? theme.fonts.fontSize.ft16 : theme.fonts.fontSize.ft14;
}, function (_ref53) {
  var isLoading = _ref53.isLoading,
    theme = _ref53.theme;
  return !isLoading ? theme.colors.border.gray : theme.colors.button.primary;
}, function (_ref54) {
  var size = _ref54.size;
  return "".concat(PADDING_Y[size], " ").concat(PADDING_X[size]);
}, function (_ref55) {
  var size = _ref55.size,
    leftIcon = _ref55.leftIcon,
    isLoading = _ref55.isLoading;
  return leftIcon || isLoading ? PADDING_ICON[size] : null;
}, function (_ref56) {
  var rightIcon = _ref56.rightIcon,
    size = _ref56.size;
  return rightIcon ? PADDING_ICON[size] : null;
});
var primary = /*#__PURE__*/css(["", ";", ";"], pill, primaryCommon);
var secondary = /*#__PURE__*/css(["", ";", ";"], pill, secondaryCommon);

/* do not use this tertiary */
var tertiary = /*#__PURE__*/css(["", ";color:", ";svg{fill:", ";stroke:", ";}&:hover{text-decoration:underline;}"], pill, function (_ref57) {
  var theme = _ref57.theme;
  return theme.colors.text.secondary;
}, function (_ref58) {
  var theme = _ref58.theme;
  return theme.colors.text.secondary;
}, function (_ref59) {
  var theme = _ref59.theme;
  return theme.colors.text.secondary;
});
var quaternary = /*#__PURE__*/css(["", ";", ";"], pill, quaternaryCommon);
var cta = /*#__PURE__*/css(["", ";border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover{background:", ";border:1px solid ", ";color:", ";}&:focus:not(:active){box-shadow:inset 0 0 0 1px rgba(255,255,255,0.37);border:1px solid rgba(255,255,255,0.37);background:", ";color:", ";}&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){background:", ";color:", ";svg{fill:", ";stroke:", ";}}"], pill, function (_ref60) {
  var theme = _ref60.theme;
  return theme.colors.button.cta;
}, function (_ref61) {
  var theme = _ref61.theme;
  return theme.colors.button.cta;
}, function (_ref62) {
  var theme = _ref62.theme;
  return theme.colors.text.white;
}, function (_ref63) {
  var theme = _ref63.theme;
  return theme.colors.text.white;
}, function (_ref64) {
  var theme = _ref64.theme;
  return theme.colors.text.white;
}, function (_ref65) {
  var theme = _ref65.theme;
  return theme.colors.background.white;
}, function (_ref66) {
  var theme = _ref66.theme;
  return theme.colors.button.cta;
}, function (_ref67) {
  var theme = _ref67.theme;
  return theme.colors.text.cta;
}, function (_ref68) {
  var theme = _ref68.theme;
  return theme.colors.button.cta;
}, function (_ref69) {
  var theme = _ref69.theme;
  return theme.colors.text.white;
}, function (_ref70) {
  var isLoading = _ref70.isLoading,
    theme = _ref70.theme;
  return !isLoading ? theme.colors.button.gray : theme.colors.button.cta;
}, function (_ref71) {
  var isLoading = _ref71.isLoading,
    theme = _ref71.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref72) {
  var isLoading = _ref72.isLoading,
    theme = _ref72.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
}, function (_ref73) {
  var isLoading = _ref73.isLoading,
    theme = _ref73.theme;
  return !isLoading ? theme.colors.text.darkGray : theme.colors.text.white;
});
var proceed = /*#__PURE__*/css(["", ";border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover{background:", ";color:", ";border:1px solid ", ";svg{fill:", ";stroke:", ";}}"], pill, function (_ref74) {
  var theme = _ref74.theme;
  return theme.colors.border.proceed;
}, function (_ref75) {
  var theme = _ref75.theme;
  return theme.colors.border.proceed;
}, function (_ref76) {
  var theme = _ref76.theme;
  return theme.colors.text.white;
}, function (_ref77) {
  var theme = _ref77.theme;
  return theme.colors.text.white;
}, function (_ref78) {
  var theme = _ref78.theme;
  return theme.colors.text.white;
}, function (_ref79) {
  var theme = _ref79.theme;
  return theme.colors.button.white;
}, function (_ref80) {
  var theme = _ref80.theme;
  return theme.colors.text.proceed;
}, function (_ref81) {
  var theme = _ref81.theme;
  return theme.colors.border.proceed;
}, function (_ref82) {
  var theme = _ref82.theme;
  return theme.colors.text.proceed;
}, function (_ref83) {
  var theme = _ref83.theme;
  return theme.colors.text.proceed;
});
var darkTertiary = /*#__PURE__*/css(["", ";border:1px solid ", ";background:", ";color:", ";svg{fill:", ";stroke:", ";}&:hover,&:focus{background:", ";color:", ";border:1px solid ", ";svg{fill:", ";stroke:", ";}}"], pill, function (_ref84) {
  var theme = _ref84.theme;
  return theme.colors.border.tertiary;
}, function (_ref85) {
  var theme = _ref85.theme;
  return theme.colors.button.tertiary;
}, function (_ref86) {
  var theme = _ref86.theme;
  return theme.colors.text.white;
}, function (_ref87) {
  var theme = _ref87.theme;
  return theme.colors.text.white;
}, function (_ref88) {
  var theme = _ref88.theme;
  return theme.colors.text.white;
}, function (_ref89) {
  var theme = _ref89.theme;
  return theme.colors.button.white;
}, function (_ref90) {
  var theme = _ref90.theme;
  return theme.colors.text.tertiary;
}, function (_ref91) {
  var theme = _ref91.theme;
  return theme.colors.border.tertiary;
}, function (_ref92) {
  var theme = _ref92.theme;
  return theme.colors.text.tertiary;
}, function (_ref93) {
  var theme = _ref93.theme;
  return theme.colors.text.tertiary;
});
var ghost = /*#__PURE__*/css(["color:", ";background-color:transparent;font-weight:", ";font-size:", ";padding:0;border:0;border-radius:0;width:auto;text-align:left;svg{fill:", ";stroke:", ";}&:hover{color:", ";background-color:transparent;text-decoration:underline;border:0;}&:focus:not(:active){border:0;background-color:transparent;color:", ";}&[disabled],&[disabled]:focus:not(:active){border:0;background-color:transparent;color:", ";padding:0;&:hover{color:", ";text-decoration:none;}svg{fill:", ";stroke:", ";}}"], function (_ref94) {
  var theme = _ref94.theme;
  return theme.colors.text.secondary;
}, function (_ref95) {
  var theme = _ref95.theme;
  return theme.fonts.fontWeight.normal;
}, function (_ref96) {
  var theme = _ref96.theme;
  return theme.fonts.fontSize.ft16;
}, function (_ref97) {
  var theme = _ref97.theme;
  return theme.colors.text.secondary;
}, function (_ref98) {
  var theme = _ref98.theme;
  return theme.colors.text.secondary;
}, function (_ref99) {
  var theme = _ref99.theme;
  return theme.colors.text.secondary;
}, function (_ref100) {
  var theme = _ref100.theme;
  return theme.colors.text.secondary;
}, function (_ref101) {
  var theme = _ref101.theme;
  return theme.colors.button.gray;
}, function (_ref102) {
  var theme = _ref102.theme;
  return theme.colors.button.gray;
}, function (_ref103) {
  var theme = _ref103.theme;
  return theme.colors.button.gray;
}, function (_ref104) {
  var theme = _ref104.theme;
  return theme.colors.button.gray;
});
var square = /*#__PURE__*/css(["width:", ";height:", ";padding:", ";background:", ";color:", ";font-weight:", ";font-size:", ";svg{fill:", ";}&:hover,&:focus{border:1px solid ", ";background:", ";color:", ";}&[disabled],&[disabled]:hover,&[disabled]:focus:not(:active){border:1px solid ", ";box-shadow:none;}"], function (_ref105) {
  var size = _ref105.size;
  return SIZE[size];
}, function (_ref106) {
  var size = _ref106.size;
  return SIZE[size];
}, function (_ref107) {
  var size = _ref107.size;
  return PADDING_Y[size];
}, function (_ref108) {
  var theme = _ref108.theme;
  return theme.colors.button.white;
}, function (_ref109) {
  var theme = _ref109.theme;
  return theme.colors.text.secondary;
}, function (_ref110) {
  var theme = _ref110.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref111) {
  var size = _ref111.size;
  return FONT_SIZES[size];
}, function (_ref112) {
  var theme = _ref112.theme;
  return theme.colors.text.secondary;
}, function (_ref113) {
  var theme = _ref113.theme;
  return theme.colors.border.primary;
}, function (_ref114) {
  var theme = _ref114.theme;
  return theme.colors.button.white;
}, function (_ref115) {
  var theme = _ref115.theme;
  return theme.colors.text.secondary;
}, function (_ref116) {
  var isLoading = _ref116.isLoading,
    theme = _ref116.theme;
  return !isLoading ? theme.colors.border.gray : theme.colors.button.primary;
});
var squareprimary = /*#__PURE__*/css(["", ";", ";"], square, primaryCommon);
var squaresecondary = /*#__PURE__*/css(["", ";", ";"], square, secondaryCommon);
var squarequaternary = /*#__PURE__*/css(["", ";", ";"], square, quaternaryCommon);
var dotprimary = /*#__PURE__*/css(["", ";border-radius:", ";width:", ";height:", ";padding:0.375rem;"], squareprimary, function (_ref117) {
  var theme = _ref117.theme;
  return theme.sizes.sz32;
}, function (_ref118) {
  var theme = _ref118.theme;
  return theme.sizes.sz32;
}, function (_ref119) {
  var theme = _ref119.theme;
  return theme.sizes.sz32;
});
var dotsecondary = /*#__PURE__*/css(["", ";border-radius:", ";width:", ";height:", ";padding:0.375rem;"], squaresecondary, function (_ref120) {
  var theme = _ref120.theme;
  return theme.sizes.sz32;
}, function (_ref121) {
  var theme = _ref121.theme;
  return theme.sizes.sz32;
}, function (_ref122) {
  var theme = _ref122.theme;
  return theme.sizes.sz32;
});
var round = /*#__PURE__*/css(["box-shadow:0 2px 8px 0 rgba(0,0,0,0.21);background:", ";width:", ";height:", ";padding:", ";font-weight:", ";font-size:", ";border-radius:50%;svg{fill:", ";}&:hover,&:focus{box-shadow:0 2px 8px 0 rgba(0,0,0,0.42);color:", ";}"], function (_ref123) {
  var theme = _ref123.theme;
  return theme.colors.button.white;
}, function (_ref124) {
  var size = _ref124.size;
  return SIZE[size];
}, function (_ref125) {
  var size = _ref125.size;
  return SIZE[size];
}, function (_ref126) {
  var size = _ref126.size;
  return PADDING_Y[size];
}, function (_ref127) {
  var theme = _ref127.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref128) {
  var size = _ref128.size;
  return FONT_SIZES[size];
}, function (_ref129) {
  var theme = _ref129.theme;
  return theme.colors.text.secondary;
}, function (_ref130) {
  var theme = _ref130.theme;
  return theme.colors.text.secondary;
});
var roundprimary = /*#__PURE__*/css(["", ";", ";box-shadow:none;&:hover,&:focus{box-shadow:none;}"], round, primaryCommon);
var roundquaternary = /*#__PURE__*/css(["", ";", ";box-shadow:none;&:hover,&:focus{box-shadow:none;}"], round, quaternaryCommon);
var rectangle = /*#__PURE__*/css(["", ";width:auto;"], square);
var variations = {
  primary: primary,
  secondary: secondary,
  tertiary: tertiary,
  quaternary: quaternary,
  cta: cta,
  proceed: proceed,
  darkTertiary: darkTertiary,
  ghost: ghost,
  square: square,
  round: round,
  roundprimary: roundprimary,
  squareprimary: squareprimary,
  squaresecondary: squaresecondary,
  squarequaternary: squarequaternary,
  roundquaternary: roundquaternary,
  dotprimary: dotprimary,
  dotsecondary: dotsecondary,
  rectangle: rectangle
};
function getVariantStyle(_ref131) {
  var variant = _ref131.variant;
  return variations[variant];
}
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "style__StyledButton",
  componentId: "sc-6yeo1r-0"
})(["display:inline-flex;justify-content:center;align-items:center;margin:0;border:1px solid rgba(0,0,0,0);text-decoration:none;cursor:pointer;line-height:1;font-family:", ";text-align:", ";", ";transition:background 150ms ease-in-out,transform 150ms ease,color 150ms ease-in-out,border 150ms ease;&:focus{outline:none;}&[disabled]{cursor:not-allowed;}svg{width:", ";height:", ";margin:", " 0;}"], function (_ref132) {
  var theme = _ref132.theme;
  return theme.fonts.fontFamily.primary;
}, function (props) {
  return props.stretch !== 'auto' && props.leftIcon !== null ? 'left' : 'center';
}, getVariantStyle, function (_ref133) {
  var size = _ref133.size;
  return ICON_SIZE[size];
}, function (_ref134) {
  var size = _ref134.size;
  return ICON_SIZE[size];
}, function (_ref135) {
  var size = _ref135.size;
  return MARGIN_ICON[size];
});
export var RightIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__RightIcon",
  componentId: "sc-6yeo1r-1"
})(["display:", ";padding-left:", ";"], function (_ref136) {
  var variant = _ref136.variant;
  return variant === 'square' ? 'none' : 'flex';
}, function (_ref137) {
  var size = _ref137.size;
  return PADDING_Y[size];
});
export var LeftIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__LeftIcon",
  componentId: "sc-6yeo1r-2"
})(["display:", ";padding-right:", ";"], function (props) {
  return props.variant.includes('square') ? 'block' : 'flex';
}, function (_ref138) {
  var size = _ref138.size,
    variant = _ref138.variant;
  return variant.includes('square') || variant === 'roundprimary' ? 0 : PADDING_Y[size];
});
export var ButtonLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__ButtonLabel",
  componentId: "sc-6yeo1r-3"
})(["flex-grow:1;"]);
export default StyledButton;